//**auto-generated don't edit this code**//
export enum Scope {
	None,
	All,
	District,
	MyTests,
}